// Library Class
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy, ViewChild, Renderer2, ViewEncapsulation, AfterViewInit, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

// Class
import { MasterConstants } from '../../../../common/constants/master-constants';
import { SRAOrdersLandingFilterVM } from '../../../../models/SRAOrders/SRAOrdersLandingFilterVM';
import { SraOrdersService } from '../../../../services/cpp/sra-orders.service';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { Router } from '@angular/router';

// Service Class
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { CppService } from '../../../../services/cpp/cpp.service';
import { CommonService } from './../../../../services/common/common.service';
import { SliderModelService } from '../../../../services/infrastructure/sliderModel.service';

@Component({
  selector: 'app-sra-orders-approve-review',
  templateUrl: './sra-orders-approve-review.component.html',
  styleUrl: './sra-orders-approve-review.component.scss'
})
export class SraOrdersAprroveReviewComponent implements OnInit {
  @ViewChild('openRequestPaginator', { read: MatPaginator }) openRequestPaginator: MatPaginator;
  private subscription = new Array<Subscription>();
  filterValueList = new Array();
  displayedColumns: string[];
  statusList: any = [{ 'id': 'N', 'value': 'Pending Records' }, { 'id': 'Y', 'value': 'Show All Records' }];
  SroRequestOrdersDataSource: MatTableDataSource<any>;
  masterConstants = MasterConstants;
  userMenuAccessList: any;
  readOnlyAccess: boolean = false;
  hasSecurityApproveAccess: boolean = false;
  hasRequestAccesse: boolean = false;
  hasApproveAccess: boolean = false;
  hasReviewApproveAccess: boolean = false;
  plAccess: boolean = false;
  isApproveRequest: boolean = false;
  isRequestFromApprove: string = '';
  headerCompany = MasterConstants.US_COMPANYCODE;
  soldToAccountList = [];
  shipToAccountList = [];
  manufacturersList = [];
  soldToAccounts = '';
  shipToAccounts = '';
  manufacturers = '';
  filteredValues = {
    productName: '',
    productLine:'',
    productCategory:''
  };
  filters: any = {
    soldToAccounts: null,
    shipToAccounts: null,
    manufacturers: null,
    showAllOrders: null
  };
  selectedCount: number = 0;
  isAllItemSelected: boolean = false;
  isItemAvailable: boolean = false;
  isRecordsLoaded: boolean = false;  
  hasEligibleRecords: boolean = false;  
  popupGridData: any;
  checkedItem: any;
  constructor(
    private router: Router,
    private cppService: CppService,
    private sraOrdersService: SraOrdersService,
    private loaderService: LoaderService,
    private toastrService: ToastrService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    public sliderModelService: SliderModelService) {
  }

  ngOnInit(): void {
    this.subscription.push(this.sraOrdersService.isApproveRequest.subscribe(x => {
      if (x[0] == true) {
        this.isRequestFromApprove = 'Y';
      }
      else if (x[0] == false) {
        this.isRequestFromApprove = 'N';
      }
      else {
        this.isRequestFromApprove = '';
      }
      this.isApproveRequest = x[0];
    }));

    if (this.isRequestFromApprove === '') {
      this.navigateToLandigPage(0);
    }
    const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
    if (evolveAccessData) {
      this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
      if (this.userMenuAccessList && this.userMenuAccessList.length > 0) {
        this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SRA_ORDERS, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
      }
      if (this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SRA_APPROVERS, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList)) {
        this.hasSecurityApproveAccess = true;
      }    
    }

    this.plAccess = this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST);

    if (this.isApproveRequest) {
      if (this.plAccess) {
        this.displayedColumns = ['action', 'account', 'location', 'deliveryLocation', 'manufacturer', 'itemNumber', 'productName', 'orderUOM', 'requestedQTY', 'releasedQTY', 'unitPrice', 'estimatedAmount', 'productLine', 'productCategory'];
      }
      else {
        this.displayedColumns = ['action', 'account', 'location', 'deliveryLocation', 'manufacturer', 'itemNumber', 'productName', 'orderUOM', 'requestedQTY', 'releasedQTY', 'productLine', 'productCategory'];
      }
    }
    else {
      if (this.plAccess) {
        this.displayedColumns = ['account', 'location', 'deliveryLocation', 'manufacturer', 'itemNumber', 'productName', 'orderUOM', 'requestedQTY', 'releasedQTY', 'unitPrice', 'estimatedAmount', 'productLine', 'productCategory'];
      }
      else {
        this.displayedColumns = ['account', 'location', 'deliveryLocation', 'manufacturer', 'itemNumber', 'productName', 'orderUOM', 'requestedQTY', 'releasedQTY', 'productLine', 'productCategory'];
      }
    }

    this.getFilterData();
    this.subscription.push(
      this.sliderModelService.sraRequestDetailsCloseSliderValue.subscribe(value => {
        if (value == true) {
          this.approveSraRequest();
        }
      })
    );
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  // set account table height
  setAccSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.TopSec').outerHeight() - $('.returnTop').outerHeight() - $('.fulfill-top-sec').outerHeight() - $('.mat-mdc-header-row').outerHeight() - 140;
      $('.tableContainer').css('max-height', templateHeight + 'px');
    }, 100);
  }

  filterRecords() {

  }

  getFilterData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.sraOrdersService.getFilterDataReviewApprove().subscribe((result: any) => {
      if (result) {
        this.shipToAccountList = result.locations;
        this.soldToAccountList = result.accounts;
        this.manufacturersList = result.manufacturers;

        this.filters['shipToAccounts'] = this.shipToAccountList.map(y => y.accountNumber).toString();
        this.filters['soldToAccounts'] = this.soldToAccountList.map(y => y.accountNumber).toString();
        this.filters['manufacturers'] = this.manufacturersList.map(y => y.id).toString();
        this.filters['showAllOrders'] = 'N';
      }
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  loadGridData() {    
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.sraOrdersService.getRequestDataReviewApprove(this.filters).subscribe((result: any) => {
      this.selectedCount = 0;
      this.isRecordsLoaded = true; 
      this.hasEligibleRecords = result && result.length > 0 && result.some(x => x.isItemEligible === true);
      this.SroRequestOrdersDataSource = new MatTableDataSource(result);
      this.popupGridData = result.filter(x => x.isPending === true);     
      this.SroRequestOrdersDataSource.paginator = this.openRequestPaginator;
      this.SroRequestOrdersDataSource.paginator.firstPage();
      this.SroRequestOrdersDataSource.filterPredicate = this.customFilterPredicate();
      if (this.SroRequestOrdersDataSource && this.SroRequestOrdersDataSource.data && this.isRequestFromApprove == 'Y') {
        this.isItemAvailable = this.SroRequestOrdersDataSource?.data.filter(x => x.isItemEligible == true).length > 0 ? true : false;
      }
      else {
        this.isItemAvailable = false;
      }
      this.isAllItemSelected = false;
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  customFilterPredicate() {
    const myFilterPredicate = function (data: any, filter: string): boolean {
      const searchString = JSON.parse(filter);
      const itemDescriptionFound = data.productName == null || data.productName.toString().trim().toLowerCase().indexOf(searchString.productName.toLowerCase()) !== -1;
      const productLineFound = data.productLine == null || data.productLine.toString().trim().toLowerCase().indexOf(searchString.productLine.toLowerCase()) !== -1;
      const productCategoryFound = data.productCategory == null || data.productCategory.toString().trim().toLowerCase().indexOf(searchString.productCategory.toLowerCase()) !== -1;
      return productLineFound && itemDescriptionFound && productCategoryFound;
    };
    return myFilterPredicate;
  }

  filterByItemDesc(event) {
    this.filteredValues['productName'] = event;
    this.SroRequestOrdersDataSource.filter = JSON.stringify(this.filteredValues);
  }

  filterByProductLine(event) {
    this.filteredValues['productLine'] = event;
    this.SroRequestOrdersDataSource.filter = JSON.stringify(this.filteredValues);
  }

  filterByProductCategory(event) {
    this.filteredValues['productCategory'] = event;
    this.SroRequestOrdersDataSource.filter = JSON.stringify(this.filteredValues);
  }

  enableCheckBoxSingle(isChecked) {
    this.selectedCount = this.SroRequestOrdersDataSource?.data.filter(x => x.isSelected == true).length;
    var eligibleCount = this.SroRequestOrdersDataSource?.data.filter(x => x.isItemEligible == true).length;
    if (eligibleCount == this.selectedCount) {
      this.isAllItemSelected = true;
    }
    else {
      this.isAllItemSelected = false;
    }
  }

  enableCheckBoxAll(isChecked) {
    if (isChecked) {
      this.SroRequestOrdersDataSource.data.filter(order => order.isItemEligible).forEach(x => x.isSelected = true);
    }
    else {
      this.SroRequestOrdersDataSource.data.filter(order => order.isItemEligible).forEach(x => x.isSelected = false);
    }
    this.selectedCount = this.SroRequestOrdersDataSource?.data.filter(x => x.isSelected == true).length;
  }

  approveSraRequest() {
    if (this.SroRequestOrdersDataSource?.data.filter(x => x.isSelected == true).length > 0) {
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.sraOrdersService.approveSraRequest(this.SroRequestOrdersDataSource?.data.filter(x => x.isSelected == true)).subscribe((result: any) => {
        if (result.status == true) {
          this.selectedCount = 0;
          this.toastrService.success("The request has been successfully approved.");
          this.navigateToLandigPage(1);
        } else if (result.status == false && result.message == "Invalid RequestedArivalDate" && result.invalidRequestItemIds) {
          this.openRequestDetailsSlider(result.invalidRequestItemIds);
        }
        else {
          this.toastrService.error(result.message);
          this.loadGridData();
        }

        this.loaderService.setLoaderStatus(false);
      }, error => {
        this.loaderService.setLoaderStatus(false);
      }));
    }
    //if (this.SroRequestOrdersDataSource?.data.filter(x => x.isSelected == true).length > 0) {
    //  if (this.SroRequestOrdersDataSource && this.SroRequestOrdersDataSource.data) {
    //    this.sliderModelService.setSraRequestDetailsValue({
    //      selectedRecords: this.selectedCount > 0 ? this.SroRequestOrdersDataSource?.data.filter(x => x.isSelected == true) : [],
    //      displayedColumns: this.displayedColumns,
    //      isApproveRequest: this.isApproveRequest,
    //      plAccess: this.plAccess,
    //      fromPlaceOrder: true
    //    });
    //    this.sliderModelService.activeSlider('sraRequestDetailsSlider');
    //  }
    //}

  }

  handleKeyevent(event) {
    if (event.keyCode == 13) {
      return false;
    }
  }

  changeFilter = (event, key) => {
    this.filters[key] = event instanceof Event ? this.filters[key] : event.join(',');
  };

  navigateToLandigPage(value:number) {
    this.commonService.currentTabIndex.next(value);
    this.router.navigate(['/cpp/orders/sra-order-landing']);
  }
  clearShipToAccounts() {
    this.filters.shipToAccounts = [];
    this.changeFilter([], 'shipToAccounts');
  }
  clearManufacturers() {
    this.filters.manufacturers = [];
    this.changeFilter([], 'manufacturers');
  }
  clearSoldToAccounts() {
    this.filters.soldToAccounts = [];
    this.changeFilter([], 'soldToAccounts');
  }
  clearAllFilter() {
    // Select all for soldToAccounts
    this.filters.soldToAccounts = this.soldToAccountList.map(y => y.accountNumber);
    this.changeFilter(this.filters.soldToAccounts, 'soldToAccounts');

    // Select all for shipToAccounts
    this.filters.shipToAccounts = this.shipToAccountList.map(y => y.accountNumber);
    this.changeFilter(this.filters.shipToAccounts, 'shipToAccounts');

    // Select all for manufacturers
    this.filters.manufacturers = this.manufacturersList.map(y => y.id);
    this.changeFilter(this.filters.manufacturers, 'manufacturers');

    // Reset status filter to default (if needed)
    this.filters['showAllOrders'] = 'N';

    // Clear text filters
    if (this.SroRequestOrdersDataSource) {
      this.filteredValues.productName = '';
      this.filterByItemDesc('');
      this.filteredValues.productLine = '';
      this.filterByProductLine('');
      this.filteredValues.productCategory = '';
      this.filterByProductCategory('');
    }   
    this.isRecordsLoaded = false;
    this.hasEligibleRecords = false;    
    // Set empty grid
    this.SroRequestOrdersDataSource = new MatTableDataSource([]);
    this.SroRequestOrdersDataSource.paginator = this.openRequestPaginator;
    this.SroRequestOrdersDataSource.paginator.firstPage();
  }

  clearProductNameFilter() {
    this.filteredValues.productName = '';
    this.filterByItemDesc('');
  }
  clearProductLineFilter() {
    this.filteredValues.productLine = '';
    this.filterByProductLine('');
  }
  clearProductCategoryFilter() {
    this.filteredValues.productCategory = '';
    this.filterByProductCategory('');
  }
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
    this.sliderModelService.setSraRequestDetailsCloseValue(false);
  }

  openRequestDetailsSlider(invalidRequestItems : any[] = []) {
    if (this.SroRequestOrdersDataSource && this.SroRequestOrdersDataSource.data) {
    this.sliderModelService.setSraRequestDetailsValue({
      selectedRecords: this.selectedCount > 0 ? this.SroRequestOrdersDataSource?.data.filter(x => x.isSelected == true) : [] ,
      displayedColumns: this.displayedColumns,
      isApproveRequest: this.isApproveRequest,
      plAccess: this.plAccess,
      mainGridData: this.SroRequestOrdersDataSource?.data.filter(x => x.isItemEligible == true),
      requestItemIds: invalidRequestItems
    });
    this.sliderModelService.activeSlider('sraRequestDetailsSlider');
  }
}
}
